import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from '~/Product/Action';
import { showAllProductsAction } from '~/Product/actions';
import { State, ThunkDispatch } from '~/Store';
import { TailwindTooltip } from '../../atoms/TailwindTooltip';
import { Checkbox } from '../../atoms/Checkbox';
import Icon from '~/UI/Icon';
import { selectCardinalPluralCzech } from '~/utils/Intl/selectCardinalPlural';

export interface Props {
	alternativeProductsCount: number;
	showTooltip?: boolean;
}

export function ProductGroupShowAllItemsSwitch({ alternativeProductsCount, showTooltip }: Props) {
	const showAllProducts = useSelector<State, boolean>((state) => state.products.showAllProducts);
	const dispatch: ThunkDispatch<Action> = useDispatch();
	const update = useCallback((showAllProducts: boolean) => {
		dispatch(showAllProductsAction(!showAllProducts));
	}, []);

	if (alternativeProductsCount === 0) {
		return null;
	}

	return (
		<label
			htmlFor='showAllProducts'
			className='inline-flex max-w-lg items-center gap-x-2 justify-end text-[12px] leading-[15px] cursor-pointer'
		>
			<Checkbox id='showAllProducts' name='showAllProducts' checked={!showAllProducts} onChange={update} />
			Skrýt {alternativeProductsCount}{' '}
			{selectCardinalPluralCzech(alternativeProductsCount, ['produkt', 'produkty', 'produktů'])}, které pocházejí z
			nereferenčních datových zdrojů nebo se již nenacházejí v aktuální verzi daného datového zdroje
			{showTooltip && (
				<TailwindTooltip
					reference={<Icon name='violet-question-mark' />}
					displayClass='relative h-4 inline-block'
					position='left'
				>
					<p className='leading-snug'>
						Products are excluded from the calculation by unchecking the <strong>Use for calc.</strong> field, either
						manually or automatically (based on the product details).
					</p>
					<p className='leading-snug'>
						By default, all products from alternative data sources, products not present in current datasets, products
						without price and products with expired validity are automatically unchecked and hidden upon inserting of
						products into the product list
					</p>
				</TailwindTooltip>
			)}
		</label>
	);
}
